module.exports = __webpack_public_path__ + "img/waist.5f00625c.png";